import storage from '../util/storage'

// whitelist of store keys
// to saved in localStorage
// do not store sensitive data
export default ({
  auth,
  calendarFilters,
  version,
  workspaceId,
  organizationId,
  showAdminPanel,
  tablesConfig,
  enforcedLocality,
  managerAssistant,
  onboarding,
  locale
}) => {
  storage.set('ds-store', {
    auth,
    calendarFilters,
    tablesConfig,
    version,
    workspaceId,
    organizationId,
    showAdminPanel,
    enforcedLocality,
    // the language picker on the logged-out cards is the only way to pick a language
    // before an account exists, so the choice has to survive a reload
    locale,
    // only the expanded/collapsed choice — planningOpen is session state, like the
    // `sidebar` slice it replaces (which was never persisted either)
    managerAssistant: { expanded: managerAssistant?.expanded },
    // everything except `tourPending`, which is session state. The tour launcher only ever
    // starts a tour on a route CHANGE, so a flag restored from a previous session can never
    // open the tour the „Vyřešit" click asked for — it can only open one later, on an
    // unrelated visit to the same page. Dropping it here also covers the reload, tab close
    // or crash during the anchor wait, which no effect cleanup is ever run for.
    onboarding: Object.fromEntries(
      Object.entries(onboarding || {}).map(([wsId, flags]) => {
        const { tourPending, ...persisted } = flags || {}
        return [wsId, persisted]
      })
    )
  })
}
